import { SAVE_USER, REFRESH_USER } from '../constants/actionTypes'

/**
 * NOTE: This structure matches the account details return schema from resi-pal.
 */
const initialState = {
  logged_in: false,
  account_confirm: false,
  has_listing: false,
  has_non_auction_listing: false,
  buyer_offer: false,
  address: '',
  assets_owned: 0,
  city: '',
  country: '',
  country_id: 0,
  email_address: '',
  first_name: '',
  last_name: '',
  mobile: '',
  phone: '',
  primary_role: 0,
  seller_codes: [],
  state_code: '',
  state_id: 0,
  title: '',
  user_id: 0,
  zip: '',
}

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case SAVE_USER:
      return Object.assign({}, state, action.user)
    case REFRESH_USER:
      return { ...action.user }
    default:
      return state
  }
}

export default userReducer
export { initialState }
